<template>
<div>
  <a
    @click="launchDialog" class="btn u-mg-t-2"
    data-block="true"
    data-color="brand"
    data-stroke="true"
  >{{ triggerLabel }}</a>
  <app-dialog
    :title="triggerLabel"
    :active="dialogVisibility"
    @close="dismissDialog">
    <div slot="content" style="margin: -12px 0">

      <el-collapse accordion v-model="currentTab">
        <el-collapse-item title="お支払い方法" name="regular-paymet">
          <payment-method-select
            accept-charset="Shift_JIS"
            :sbps-api-url="sbpsApiUrl"
            :form-param="formParam"
            :order-id="orderId"
            :merchant-id="merchantId"
            :service-id="serviceId"
            :docomo-informal-payment-array="docomoInformalPaymentArray"
            :kddi-informal-payment-array="kddiInformalPaymentArray"
            :softbank-informal-payment-array="softbankInformalPaymentArray"
          ></payment-method-select>
        </el-collapse-item>

        <el-collapse-item title="＋ カード情報を変更" name="new-card">
          <div v-if="sbpsPaymentError && sbpsError.error_message" class="alert" data-color="error">
            <b v-if="sbpsError.error_code">
              {{ sbpsError.error_code }}: {{ sbpsError.error_title }}
            <br></b>
            <span>{{ sbpsError.error_message }}</span>
          </div>

          <form
            action="/payment/complete" method="post"
            ref="paymentUpdateForm"
            @submit.prevent="updateCardData()">
            <input type="hidden" name="_token" :value="token">
            <input type="hidden" name="order_id" :value="orderId">
            <input type="hidden" name="merchant_id" :value="merchantId">
            <input type="hidden" name="service_id" :value="serviceId">
            <input type="hidden" name="token" ref="token">
            <input type="hidden" name="tokenKey" ref="tokenKey">
            <input type="hidden" name="cardbrandCode" ref="cardbrandCode">
            <input type="hidden" v-for="(value, key) in formParam" :key="key" :name="key" :value="value">

            <form-credit-card
              label="カード番号"
              name="ccNumber"
              data-vv-name="cc_number"
              data-vv-value-path="formattedValue"
              v-model="ccNumber"
              :validation="{ rules: {
                required: true,
                credit_card: true
              } }"
            ></form-credit-card>
            <input type="hidden" ref="ccNumber" name="cc_number">

            <form-credit-expire
              name=""
              label="カード有効期限"
              month-name="cc_expiration_m"
              year-name="cc_expiration_y"
              :validation="{ rules: { required: true } }"
              v-model="ccExpiration"
            ></form-credit-expire>

            <div class="securityCode">
              <form-input
                label="セキュリティコード"
                name="security_code"
                v-model="securityCode"
                type="tel"
                input-width="72px"
                :validation="{ rules: {
                  required: true,
                  numeric: true,
                  max: 4
                } }"
              ></form-input>
              <div class="securityCode__question" @click="toggleAboutSecurityCode">
                <img width="20" height="20" src="/static/img/icons/question.svg">
              </div>
              <div class="securityCode__about media" :data-visible="visibleAboutSecurityCode">
                <div class="media__image">
                  <img src="/static/img/security-code.png" width="48" height="30">
                </div>
                <div class="media__content">
                  <p>セキュリティコードはカード裏面に記載されている３桁または、表面に記載されている４桁の番号です。</p>
                </div>
              </div>
            </div>

            <input type="hidden" name="cust_manage_flg" value="1">

            <div class="u-tx-right">
              <button class="btn" data-size="sm" data-color="primary" type="submit">お支払い</button>
            </div>
          </form>
        </el-collapse-item>

      </el-collapse>
    </div>
  </app-dialog>
</div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'change-payment-dialog',
  data() {
    return {
      hoge: "",
      token: window.Laravel.csrfToken,
      triggerLabel: '別のお支払い方法を使う',
      currentTab: 'regular-paymet',
      dialogVisibility: false,
      displayCardStr: '',
      ccNumber: '',
      ccExpiration: '',
      securityCode: '',
      sbpsPaymentError: false,
      sbpsError: {},
      visibleAboutSecurityCode: false
    }
  },
  props: {
    orderId: String,
    merchantId: String,
    serviceId: String,
    custManageFlg: [String, Number],
    formParam: Object,
    sbpsApiUrl: String,
    docomoInformalPaymentArray: Object,
    kddiInformalPaymentArray: Object,
    softbankInformalPaymentArray: Object
  },
  computed: {
    ...mapState({
      card: state => state.payment.card,
      auth: state => state.auth
    }),
    ...mapGetters(['cardNumberStr'])
  },
  methods: {
    launchDialog() {
      this.dialogVisibility = true;
    },
    dismissDialog() {
      this.dialogVisibility = false;
    },
    isValid() {
      if (!this.ccNumber || !this.securityCode || !this.ccExpiration) {
        this.sbpsPaymentError = true
        this.sbpsError = {
          error_message: '入力されていない項目があります。'
        }
        return false
      }
      return true
    },
    updateCardData() {
      if (!this.isValid()) {
        return;
      }

      if (!window.com_sbps_system) {
        throw new Error('Error: window.com_sbps_system がありません。')
      }

      const data = {
        merchantId: this.merchantId,
        serviceId: this.serviceId,
        ccNumber: this.ccNumber,
        ccExpiration: `20${this.ccExpiration.year}${
          this.ccExpiration.month
        }`,
        securityCode: this.securityCode
      }
      window.com_sbps_system.generateToken(data, this.afterGenerateToken)
    },
    toggleAboutSecurityCode() {
      this.visibleAboutSecurityCode = !this.visibleAboutSecurityCode
      if (this.visibleAboutSecurityCode) {
        setTimeout(this.toggleAboutSecurityCode, 5000)
      }
    },
    afterGenerateToken(response) {
      if (response.result == 'OK') {
        this.sbpsPaymentError = false
        this.sbpsErrorMessage = {}
        const { tokenResponse } = response

        this.$store.dispatch('UPDATE_PAYMENT_INFO', {
          access_token: this.auth.accessToken,
          token: tokenResponse.token,
          tokenKey: tokenResponse.tokenKey
        }).then(res => {
          // カード情報更新成功時
          this.$refs.token.value = tokenResponse.token
          this.$refs.tokenKey.value = tokenResponse.tokenKey
          this.$refs.cardbrandCode.value = tokenResponse.cardbrandCode
          // カード情報をマスクされた番号で上書き
          this.$refs.ccNumber.value = tokenResponse.maskedCcNumber
          this.$refs.paymentUpdateForm.submit()
        }).catch(error => {
          this.sbpsPaymentError = true
          this.sbpsError = error
        })
      } else {
        this.sbpsPaymentError = true
      }
    }
  }
}</script>

<style lang="scss">
.securityCode {
  position: relative;
  &__question {
    position: absolute;
    left: 88px;
    top: 35px;
    cursor: pointer;
  }
  &__about {
    position: absolute;
    background: rgba(0,0,0,.7);
    color: #FFF;
    padding: 8px;
    z-index: 2;
    box-shadow: rgba(0, 0, 0, 0.2) 0px 2px 4px;
    border-radius: 4px;
    left: 120px;
    top: 0;
    align-items: center;
    pointer-events: none;
    opacity: 0;
    transition: opacity 250ms ease-in-out;
    &[data-visible='true'] {
      opacity: 1;
      pointer-events: auto;
    }
    .media__content p {
      font-size: 10px;
      line-height: 14px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Payment/ChangePaymentDialog.vue